module.exports = __webpack_public_path__ + "static/9s-9ec980e9cba128d5ae4993dd65867549.jpg";